import React from 'react';
import { Link } from 'vindi-ds-components';
import Header from '@templates/header';

function HeaderReport({ isMobile }) {
  return (
    <>
      {isMobile ? (
        <Header.Mobile
          links='/admin/dashboard'
          title='Relatórios'
        />
      ) : (
        <Header.Default
          links={[<Link href='/admin/dashboard'>Início</Link>]}
          title='Relatórios'
        />
      )}
    </>
  );
}

export default HeaderReport;
